import { Injectable } from '@angular/core';
import { Permissions } from '../../state/models/access-control-list.model';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthStatements } from '../../state/models/auth-statements';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AclService {
  permissions: string[];

  constructor(
    private http: HttpClient,
  ) {
  }

  private fetchPermissions(roleIds: string, authStatements: AuthStatements[]): Observable<{
    authStatements: AuthStatements[],
    permissions: Permissions[]
  }> {
    const params = { roleIds };
    return this.http.get<Permissions[]>(`${ environment.apiUrl }/permissions`, { params }).pipe(
      map((response: any) => response?.permissions as Permissions[]),
      tap(permissions => {
        this.permissions = permissions.map(permission => {
          return permission.name;
        });
      }),
      map((permissions) => {
        return { authStatements, permissions };
      }),
    );
  }

  public getRoles(personId: number): Observable<{
    authStatements: AuthStatements[],
    permissions: Permissions[]
  }> {
    const principalPersonIds = personId;
    const params = { principalPersonIds };
    return this.http.get<AuthStatements[]>(`${ environment.apiUrl }/auth-statements`, { params }).pipe(
      map((response: any) => response?.authStatements as AuthStatements[] ?? []),
      switchMap(authStatements => {
        const ids = authStatements.map(authStatement => {
          return authStatement.role.id;
        });
        return this.fetchPermissions(ids.toString(), authStatements);
      }),
    );
  }

  /**
   * Checks if the specified permission exists within the user's permissions.
   *
   * @param {string} permission - The permission to check.
   * @returns {boolean} - Returns `true` if the permission is found, otherwise `false`.
   */
  public hasPermission(permission: string): boolean {
    return this.permissions.some(p => {
      return p === permission;
    });
  }

}

